exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-group-users[data-v-23c4c94b]{max-height:400px;overflow-y:auto}.user-group-users-list tbody tr:first-child td[data-v-23c4c94b]{border-top:none}", ""]);

// exports
